import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebApiService } from './web-api.service';

@Injectable({
  providedIn: 'root',
})
export class PlayerService {
  private apiUrl = 'Player';

  constructor(private http: WebApiService) {}

  updatePlayerStats(change: {
    id: number;
    pp_point_change: number;
    wins_change: number;
    loses_change: number;
    point_change: number;
  }): Observable<any> {
    return this.http.post(this.apiUrl, change);
  }
}
